import { CodigoEquipoModel } from '@/store/catalogos/codigoEquipo';
import { Colaborador } from '@/store/catalogos/colaborador';
import { properties } from '@/utils/properties';
import { Util } from '@/utils/util';
import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CatalogoCodigoEquipoService } from '@services/catalogo/catalogoCodigoEquipo.service';
import { CatalogoColaboradorService } from '@services/catalogo/catalogoColaborador.service';
import { ValidatorsService } from '@services/util/validators.service';
import { map, Observable, startWith } from 'rxjs';
import { resolve } from 'path';

@Component({
  selector: 'app-formulario-codigo-equipo',
  templateUrl: './formulario-codigo-equipo.component.html',
  styleUrls: ['./formulario-codigo-equipo.component.scss']
})
export class FormularioCodigoEquipoComponent {
  form: FormGroup;
  mostrarBoton: boolean = true;
  title = "Nuevo Código de Equipo";

  colaboradorControl = new FormControl<string>('', Validators.required);
  colaboradorList: Colaborador[] = [];
  filteredColaboradores$: Observable<Colaborador[]>;


  constructor(
    private util: Util,
    private datePipe: DatePipe,
    private catalogoService: CatalogoColaboradorService,
    private catalogoCodigoEquipoService: CatalogoCodigoEquipoService,
    public dialogRef: MatDialogRef<FormularioCodigoEquipoComponent>,
    private validatorsService: ValidatorsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data.update) {
      this.title = "Modificar Código de Equipo";
    }
    if (data.view) {
      this.title = "Vista Código de Equipo";
    }
  }

  ngOnInit(): void {
    this.buildForm(this.data?.row);
    this.colaboradorLista().then(() => {
    });
    this.filteredColaboradores$ = this.colaboradorControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );

  }

  private _filter(value: string): Colaborador[] {
    const filterValue = value.trim().toLowerCase();
    return this.colaboradorList.filter(colaborador =>
      (`${colaborador.nombre} ${colaborador.apellidoPaterno} ${colaborador.apellidoMaterno}`)
        .toLowerCase()
        .includes(filterValue) ||
      colaborador.idColaborador.toString().includes(filterValue)
    );
  }

  async colaboradorLista(): Promise<void> {
    this.catalogoService.getAll().subscribe(data => {
      this.colaboradorList = data;
      if (this.data?.row?.realizo?.idColaborador) {  // Se valida que no sea null, undefined o vacío
        const colaboradorSeleccionado = this.colaboradorList.find(
          (col) => col.idColaborador === this.data?.row?.realizo?.idColaborador
        );

        if (colaboradorSeleccionado) {
          this.colaboradorControl.setValue(
            `${colaboradorSeleccionado.nombre} ${colaboradorSeleccionado.apellidoPaterno} ${colaboradorSeleccionado.apellidoMaterno}`
          );

          this.form.get('realizo')?.setValue(colaboradorSeleccionado.idColaborador);
        }
      }
      resolve();
    }, error => {
      this.util.errorMessage("Error al obtener lista de colaboradores.");
      resolve();
    });
  }


  private buildForm(data: CodigoEquipoModel): void {
    this.form = new FormGroup({
      idCodigoEquipo: new FormControl(data?.idCodigoEquipo ?? null),
      nombreEquipo: new FormControl(data?.nombreEquipo ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(90)]
      }),
      claveEquipo: new FormControl(data?.claveEquipo ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(20)]
      }),
      procedimiento: new FormControl(data?.procedimiento ?? '', {
        validators: [Validators.maxLength(20)]
      }),
      realizo: new FormControl(data?.realizo?.idColaborador ?? '', {
      }),
      fechaAutorizacion: new FormControl(this.datePipe.transform(data?.fechaAutorizacion, 'yyyy-MM-dd'), {
      })
    });

    if (this.data.view) {
      this.form.disable();
      this.colaboradorControl.disable();
      this.mostrarBoton = false;
    }
  }

  seleccionarColaborador(event: any) {
    const colaboradorSeleccionado = event.option.value;
    if (colaboradorSeleccionado) {
      this.colaboradorControl.setValue(
        `${colaboradorSeleccionado.nombre} ${colaboradorSeleccionado.apellidoPaterno} ${colaboradorSeleccionado.apellidoMaterno}`
      );

      this.form.get('realizo')?.setValue(colaboradorSeleccionado.idColaborador);
    }
  }

  abrirAutocomplete() {
    if (!this.colaboradorControl.value) {
      this.colaboradorControl.setValue(' ');
      this.colaboradorControl.setValue('');
    }
  }

  isValidField(field: string): boolean {
    return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
  }


  getFieldError(field: string): string {
    return this.validatorsService.getFieldError(this.form, field);
  }


  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const codigoEquipo: CodigoEquipoModel = this.formToModel();
    const request = this.data.insert
      ? this.catalogoCodigoEquipoService.create(codigoEquipo)
      : this.catalogoCodigoEquipoService.update(codigoEquipo);


    request.subscribe(response => {
      if (response.success) {
        this.util.successMessage("Registro guardado con éxito!");
        this.dialogRef.close({ data: response });
      } else {
        const errorMsg = this.util.isEmpty(response.message)
          ? "Ocurrió un error al guardar el registro"
          : response.message;
        this.util.errorMessage(errorMsg);
      }
    });
  }


  private formToModel(): CodigoEquipoModel {
    const formValues = this.form.getRawValue();

    return {
      idCodigoEquipo: formValues.idCodigoEquipo ?? '',
      nombreEquipo: formValues.nombreEquipo ?? '',
      claveEquipo: formValues.claveEquipo ?? '',
      procedimiento: formValues.procedimiento ?? '',
      fechaAutorizacion: formValues.fechaAutorizacion ?? '',
      realizo: {
        idColaborador: formValues.realizo ?? ''
      }
    };
  }
}
